var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBackBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0116,
    rx: 4,
    fill: "#EDEDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2099 6.2958C15.117 6.20207 15.0064 6.12768 14.8845 6.07691C14.7627 6.02614 14.632 6 14.4999 6C14.3679 6 14.2372 6.02614 14.1154 6.07691C13.9935 6.12768 13.8829 6.20207 13.7899 6.2958L8.78994 11.2958C8.69621 11.3888 8.62182 11.4994 8.57105 11.6212C8.52028 11.7431 8.49414 11.8738 8.49414 12.0058C8.49414 12.1378 8.52028 12.2685 8.57105 12.3904C8.62182 12.5122 8.69621 12.6228 8.78994 12.7158L13.7899 17.7158C13.8829 17.8095 13.9935 17.8839 14.1154 17.9347C14.2372 17.9855 14.3679 18.0116 14.4999 18.0116C14.632 18.0116 14.7627 17.9855 14.8845 17.9347C15.0064 17.8839 15.117 17.8095 15.2099 17.7158C15.3037 17.6228 15.3781 17.5122 15.4288 17.3904C15.4796 17.2685 15.5057 17.1378 15.5057 17.0058C15.5057 16.8738 15.4796 16.7431 15.4288 16.6212C15.3781 16.4994 15.3037 16.3888 15.2099 16.2958L10.9099 12.0058L15.2099 7.7158C15.3037 7.62284 15.3781 7.51223 15.4288 7.39038C15.4796 7.26852 15.5057 7.13781 15.5057 7.0058C15.5057 6.87379 15.4796 6.74308 15.4288 6.62122C15.3781 6.49936 15.3037 6.38876 15.2099 6.2958Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBoxIcon);
export default __webpack_public_path__ + "static/media/arrow-back-box-icon.a383dc1352be90af55c962439667f550.svg";
export { ForwardRef as ReactComponent };